<template>
  <v-container
    class="TransactionList">
    <TransactionCriteria
      :baseCrudKey="baseCrudKey"
      @loadCRUDList="handleLoadCRUDList"
    />
    <CRUDList
      ref="crudList"
      :canAdd="true"
      :canEdit="true"
      :canSave="true"
      :headers="headers"
      :showDate="true"
      :baseCrudKey="baseCrudKey"
      :createNewItem="newItemDialog"
      toolbarTitle="Bank Reconciliation"
      @loadCRUDList="handleLoadCRUDList"
      @upsertItem="upsrtTransaction"
    >
      <template v-slot:[`editedItem`]="{}">
        <TransactionEditedItem
        :baseCrudKey="baseCrudKey"
        />
      </template>
      <template v-slot:[`additionalActions`]="{}">
        <v-row>
          <v-col cols="2">
          </v-col>
          <v-col cols="10">
            <v-btn :class="`input-text-size`"
                text color="blue darken-1"
                @click="openBankReconReport"
                >Print  Reconcilation</v-btn>
          </v-col>
            </v-row>
            <v-btn :class="`input-text-size`"
            text color="blue darken-1"
            @click="deleteItem"
            >Delete</v-btn>
      </template>
    </CRUDList>
  </v-container>
</template>
<script>
import {
  mapActions, mapGetters, mapMutations, mapState,
} from 'vuex';
import TransactionCriteria from './TransactionCriteria.vue';
import CRUDList from '../../common/base/crud/CRUDList.vue';
import TransactionEditedItem from './TransactionEditedItem.vue';
import {
  getFYList, getMaxFY, toFiscalYear, updateDateFormat,
} from '../../../util/shared/tmc-global';
import {
  amountFormat, amountToNumber, checkStringEmptiness, extractId,
} from '../../../util/shared/vue-global';
import { clients } from '../../../util/clients';
import { queryStringCalcForReconReports } from '../Sai/report.util';
import { getRawJwt } from '../../../util/jwt';

const { backendRest } = clients.direct;
const getHeaders = () => {
  const headers = [
    { text: 'As of Date', value: 'asOfDate' },
    { text: 'Bank', value: 'bank.bankName' },
    {
      text: 'Bank Balance Statement', value: 'bankBalStmnt', formatter: 'amount', align: 'right',
    },
    {
      text: 'Reconcilement', value: 'reconcilement', formatter: 'amount', align: 'right',
    },
    {
      text: 'Adjusted Bank Balance ', value: 'adjBankBal', formatter: 'amount', align: 'right',
    },
    {
      text: 'GL Bank Balance', value: 'generalLedgerBalance', formatter: 'amount', align: 'right',
    },
    {
      text: 'Difference', value: 'differenceBalance', formatter: 'amount', align: 'right',
    },
  ];
  return headers;
};
export default {
  data: () => ({
    baseCrudKey: 'bankReconciliation',
    headers: [],
    dateForCriteria: ['asOfDate'],
  }),
  created() {
    this.initCriteria();
    this.loadLists();
  },
  components: {
    CRUDList,
    TransactionCriteria,
    TransactionEditedItem,
  },
  computed: {
    ...mapGetters(['todaysDate']),
    ...mapGetters('base/crud', [
      'criteria',
      'index',
      'item',
      'items',
    ]),
    ...mapState({
      fiscalYearRange: (state) => {
        const registerdYears = state.glDaily.glDailyTransaction.regYears || {};
        return getFYList(registerdYears);
      },
    }),
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
    queryStringForSaiReconciliation: {
      cache: false,
      get() {
        const bankId = ((this.item(this.baseCrudKey) || {}).bank || {})._id;
        return queryStringCalcForReconReports({
          criteria: this.criteriaState,
          singleBank: bankId,
          token: this.getAuthToken,
        });
      },
    },
    getAuthToken() {
      return getRawJwt();
    },
  },
  methods: {
    ...mapMutations('base/crud', [
      'setCriteria',
      'setItems',
      'setItem',
      'setIsVisible',
    ]),
    ...mapActions('glDaily/saiBankReconciliation', [
      'loadSaiBankReconTrans',
      'upsertSaiBankReconTrans',
      'deleteSaiBankReconTrans',
    ]),
    ...mapActions('shared/bank', [
      'loadBanks',
    ]),
    ...mapActions('glDaily/saiBankCodes', [
      'loadSaiBankCodesTrans',
    ]),
    handleLoadCRUDList() {
      const { baseCrudKey } = this;
      const criteria = this.updateCriteriaForReq();
      if (!checkStringEmptiness(this.criteriaState.asOfDate)) {
        this.loadSaiBankReconTrans({
          criteria,
          baseCrudKey,
          postProccessBankReconciliation: (dataItems) => dataItems.map((dataItem) => {
            const {
              bankBalStmnt, adjBankBal, reconcilement, differenceBalance,
            } = this.calculateBankBalances(dataItem);
            return {
              ...dataItem,
              bankBalStmnt,
              adjBankBal,
              reconcilement,
              differenceBalance,
              generalLedgerBalance: amountFormat(amountToNumber(dataItem.generalLedgerBalance)),
            };
          }),
        });
      }
    },
    async upsertInvestmentData() {
      const item = this.item(this.baseCrudKey);
      const result = await this.upsrtTransaction(item);
      if (result) {
        if (!item._id) {
          this.setItem([this.baseCrudKey, result]);
        }
        return result._id;
      }
      return null;
    },
    async openBankReconReport() {
      const isValidForm = this.$refs.crudList.$refs.crudDialog.validateForm();
      if (isValidForm) {
        const investmentTransId = await this.upsertInvestmentData();
        if (investmentTransId) {
          this.printBankReconReport();
        }
      }
    },
    printBankReconReport() {
      const bankId = extractId((this.editedItem || {}).bank);
      const queryString = queryStringCalcForReconReports({
        criteria: this.criteriaState,
        singleBank: bankId,
        token: this.getAuthToken,
      });
      const toUrl = `${backendRest.defaults.baseURL}/gl/sai/transactions/printSaiBankReconciliation${queryString}`;
      window.open(toUrl);
    },
    updateCriteriaForReq() {
      const updatedCriteria = updateDateFormat(this.criteriaState, this.dateForCriteria);
      return updatedCriteria;
    },
    async upsrtTransaction(item) {
      const { baseCrudKey } = this;
      const updatedItem = { ...item };
      updatedItem.bank = extractId(updatedItem.bank);
      delete updatedItem.bankBalStmnt;
      delete updatedItem.adjBankBal;
      delete updatedItem.reconcilement;
      delete updatedItem.differenceBalance;
      updatedItem.generalLedgerBalance = amountToNumber(updatedItem.generalLedgerBalance);
      if ((updatedItem.details || []).length > 0) {
        updatedItem.details = updatedItem.details.map((element) => {
          const amount = amountToNumber(element.amount);
          const detailItem = { ...element };
          detailItem.bankCode = extractId(detailItem.bankCode);
          return { ...detailItem, amount };
        });
      }
      const response = await this.upsertSaiBankReconTrans({
        item: updatedItem,
        baseCrudKey,
        postProccessBankReconciliation: (dataItem) => {
          const {
            bankBalStmnt, adjBankBal, reconcilement, differenceBalance,
          } = this.calculateBankBalances(dataItem);
          return {
            ...dataItem,
            bankBalStmnt,
            adjBankBal,
            reconcilement,
            differenceBalance,
            generalLedgerBalance: amountFormat(dataItem.generalLedgerBalance),
          };
        },
      });
      return response;
    },
    async deleteItem() {
      const itemVal = this.item(this.baseCrudKey);
      const { isSaiMonthly } = itemVal;
      if (isSaiMonthly) {
        alert('Please uncheck Sai Monthly checkBox for deleting the Record!');
      } else if (window.confirm('Are you sure you want to delete this item?')) {
        const { baseCrudKey } = this;
        await this.deleteSaiBankReconTrans({ item: itemVal, baseCrudKey });
        this.setIsVisible([baseCrudKey, false]);
      }
    },
    loadBankList() {
      const bankList = this.loadBanks({
        criteria: {},
        baseCrudKey: 'sharedBank',
      });
      return bankList;
    },
    loadBankCodesList() {
      const bankCodeList = this.loadSaiBankCodesTrans({
        criteria: {},
        baseCrudKey: 'bankCodes',
      });
      return bankCodeList;
    },
    async initializeFiscalYears() {
      if ((this.fiscalYearRange || []).length > 0) {
        const maxFY = getMaxFY(this.fiscalYearRange || []);
        this.criteriaState.fiscalYear = maxFY;
      }
      this.handleLoadCRUDList();
    },
    initCriteria() {
      this.headers = getHeaders();
      this.criteriaState.fiscalYear = toFiscalYear(new Date(this.todaysDate));
      this.setItems([this.baseCrudKey, []]);
    },
    newItemDialog() {
      let newItem = {};
      newItem = {
        asOfDate: this.criteriaState.asOfDate || this.todaysDate,
        fiscalYear: toFiscalYear(new Date(this.criteriaState.asOfDate || this.todaysDate)),
        details: [{
          description: '',
          addDeduct: '',
          amount: 0.0,
        }],
      };
      return newItem;
    },
    loadLists() {
      this.loadBankList();
      this.loadBankCodesList();
      this.initializeFiscalYears();
    },
    calculateBankBalances(dataItem) {
      let bankBalance = 0.0;
      let adjBankBal = 0.0;
      let reconcilement = 0.0;
      let differenceBalance = 0.0;
      const copyDataItem = { ...dataItem };
      for (let i = 0; i < dataItem.details.length; i += 1) {
        const detailsItem = { ...dataItem.details[i] };
        if (detailsItem.addDeduct === 'BANKBAL') {
          bankBalance = amountToNumber(bankBalance) + amountToNumber(detailsItem.amount);
          copyDataItem.bankBalStmnt = amountFormat(bankBalance);
        } else if (detailsItem.addDeduct !== 'BANKBAL') {
          reconcilement += amountToNumber(detailsItem.amount);
        }
        adjBankBal = amountToNumber(adjBankBal) + amountToNumber(detailsItem.amount);
        copyDataItem.adjBankBal = amountFormat(adjBankBal);
        copyDataItem.reconcilement = amountFormat(reconcilement);
      }
      differenceBalance = amountToNumber(adjBankBal)
      - amountToNumber(copyDataItem.generalLedgerBalance);
      copyDataItem.differenceBalance = amountFormat(Math.abs(differenceBalance));
      return {
        bankBalStmnt: copyDataItem.bankBalStmnt,
        adjBankBal: copyDataItem.adjBankBal,
        reconcilement: copyDataItem.reconcilement,
        differenceBalance: copyDataItem.differenceBalance,
      };
    },
  },
};
</script>
<style>
</style>
